import React from "react";
import ServiceAreas from "../../Professional/ServiceAreas/ServiceAreas";
import { getMobileRedirectionAuthToken } from "../../../Helper/mobileAuth";

const AddServiceAreaWebFromMobile = () => (
  <ServiceAreas mobileToken={getMobileRedirectionAuthToken()} />
);

export default AddServiceAreaWebFromMobile;
